import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const ElementChart = ({ elements, scores, onElementClick, selectedElement }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current || elements.length === 0) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }
    
    const chart = chartInstance.current;

    const indicators = elements.map(element => ({
      name: element.title || 'Unbenannt',
      max: 7, // Updated max scale to 7
      color: '#152627'
    }));

    const dataValues = elements.map(element => scores[element.id] || 0);

    const option = {
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#87ff8f',
        borderWidth: 1,
        textStyle: {
          color: '#15191a'
        },
        formatter: (params) => {
          let result = `<div class="font-bold mb-1 text-[#152627]">${params.name}</div>`;
          elements.forEach((el) => {
            const score = scores[el.id] || 0;
            result += `<div class="flex justify-between min-w-[150px]"><span class="mr-4">${el.title}:</span> <b>${score}</b></div>`;
          });
          return result;
        }
      },
      radar: {
        indicator: indicators,
        shape: 'polygon',
        radius: '65%',
        center: ['50%', '55%'],
        splitNumber: 7, // Updated split number to 7 for 1-7 scale
        axisName: {
          fontSize: 11,
          fontWeight: 600,
          padding: [3, 5],
          color: '#152627' 
        },
        splitArea: {
          areaStyle: {
            color: ['#f8fafc', '#f1f5f9', '#e2e8f0', '#cbd5e1', '#94a3b8', '#64748b', '#475569'].reverse().slice(0, 7),
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 5
          }
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(21, 38, 39, 0.2)'
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(21, 38, 39, 0.2)'
          }
        }
      },
      series: [
        {
          name: 'Team Durchschnitt',
          type: 'radar',
          data: [
            {
              value: dataValues,
              name: 'Team Score',
              symbol: 'circle',
              symbolSize: 6,
              itemStyle: {
                color: '#152627',
                borderColor: '#87ff8f',
                borderWidth: 2
              },
              lineStyle: {
                width: 3,
                color: '#152627'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(135, 255, 143, 0.6)' },
                  { offset: 1, color: 'rgba(135, 255, 143, 0.1)' }
                ])
              }
            }
          ]
        }
      ]
    };

    chart.setOption(option);

    const handleChartClick = (params) => {
       // Interaction handled via buttons below
    };
    
    chart.on('click', handleChartClick);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      chart.off('click', handleChartClick);
      window.removeEventListener('resize', handleResize);
      chart.dispose();
      chartInstance.current = null;
    };
  }, [elements, scores]);

  return (
    <div className="flex flex-col items-center w-full">
      <div 
        ref={chartRef} 
        style={{ width: '100%', height: '400px' }}
      />
      <div className="flex flex-wrap justify-center gap-2 mt-4">
        {elements.map((el) => (
           <button
             key={el.id}
             onClick={() => onElementClick(el)}
             className={`px-3 py-1 text-xs font-medium rounded-full transition-colors border ${
               selectedElement && selectedElement.id === el.id
                 ? 'bg-[#152627] text-white border-[#152627] shadow-sm'
                 : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-200'
             }`}
           >
             {el.title} ({scores[el.id] || 0})
           </button>
        ))}
      </div>
    </div>
  );
};

export default ElementChart;